import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {penActions, selectPenSelectorStyle, selectPenType} from "../../pen/penSlice";
import {BasePenToolOptions} from "../../../../../../base-konva/features/pen";
import {LineStyle, PenToolType} from "../../../../../../base-konva/types";
import {selectStylusOnlyMode, viewActions} from "../../view/viewSlice";
import {useDeviceType} from "../../../../../../../hooks/useDeviceType";
import {ButtonsGroup, ButtonsGroupDivider} from "../../../../../../../components/layout";

export const PenToolOptions: React.FC = () => {
	const dispatch = useDispatch();
	const penType = useSelector(selectPenType);
	const penSelectorStyle = useSelector(selectPenSelectorStyle);
	const stylusOnlyMode = useSelector(selectStylusOnlyMode);
	const {isTouchDevice} = useDeviceType();

	function handleStyleSave(style: LineStyle) {
		dispatch(penActions.changePenStyle(style));
	}

	function handlePenTypeChange(type: PenToolType) {
		dispatch(penActions.changePenType(type))
	}

	return (
		<>
			<BasePenToolOptions
				penType={penType}
				penSelectorStyle={penSelectorStyle}
				onStyleSave={handleStyleSave}
				onPenTypeChange={handlePenTypeChange}
			/>
			{isTouchDevice && (
				<>
					<ButtonsGroupDivider/>
					<ButtonsGroup>
						<button
							title="Stylus only — rejects mouse/finger input"
							className={"icon-selectable" + (stylusOnlyMode ? " is-active" : "")}
							onClick={() => dispatch(viewActions.toggleStylusOnlyMode())}
						>
							<svg width={18} height={18} viewBox="0 0 18 18" fill="currentColor">
								<path d="M13.5 1.5 14.5 2.5 5 12l-2 .5.5-2 10-9zM4 14h10v1H4z"/>
							</svg>
						</button>
					</ButtonsGroup>
				</>
			)}
		</>
	)
}
